import React from 'react';
import { BucketLogData } from '@bucketplace/bucket-log';
import { CommerceProductCard, ProductCardProps, getGoodsDetailPageUrl } from '@bucketplace/common';

import { APP_PROFILE } from 'common';
import { SuperLink } from 'components/Layout';

export interface ScrapChildScrapParams {
  bucketLogData?: Omit<BucketLogData, 'category' | 'type' | 'id'>;
  amplitudeLogData?: { scrappedFrom?: string };
}

export function ProductCardWithScrap ({
  product,
  className,
  logData,
}: ProductCardProps): React.ReactElement {
  // const router = useRouter();
  // const { userInfo } = useUserContext();
  // const isLoggedIn = userInfo?.user != null;
  // const userId = userInfo?.user?.userId;
  // const handleScrap = async ({ type, id }: ProductScrapActionParams): Promise<ProductScrapResponse> => {
  //   const {
  //     success,
  //     collectionId,
  //     collectCount,
  //     message,
  //   } = await createScrap({ type, id });
  //   return {
  //     success,
  //     collectCount,
  //     message,
  //     id: collectionId,
  //   };
  // };
  // const handleUnscrap = async ({ type, id }: ProductScrapActionParams): Promise<ProductScrapResponse> => {
  //   const {
  //     success,
  //     collectCount,
  //     message,
  //   } = await deleteScrap({ type, id });
  //   return {
  //     success,
  //     collectCount,
  //     message,
  //   };
  // };
  // const handleCreateCollectionBook = async ({ name }: { name: string }) => {
  //   const { success, id } = await createCollectionBook({ name });
  //   return { success, id };
  // };
  // const handleMoveCollectionBookItemList = async ({ collectionBookId, ids }: {
  //   collectionBookId: number,
  //   ids: number[],
  // }): Promise<{ success: boolean }> => {
  //   const { success } = await moveCollectionBookItems(collectionBookId, ids);
  //   return { success };
  // };
  // const redirectToLogin = () => {
  //   router.push(`${SIGN_IN_URL}${encodeURIComponent(router.asPath)}`);
  // };
  // const handleClickScrapBook = () => {
  //   if (!isLoggedIn) {
  //     redirectToLogin();
  //   }
  //   router.push(`${OHS_HOST}/users/${userId}/collections`);
  // };
  // const handleClickScrapBookTo = (scrapBookId: number) => {
  //   router.push(`${OHS_HOST}/collection_books/${scrapBookId}`);
  // };

  // const scrapData = createProductScrapData({
  //   userId,
  //   scrappedFrom: '썸네일',
  //   onScrap: () => () => {/* noop */},
  //   onUnscrap: () => {/* noop */},
  //   onCreateScrap: handleScrap,
  //   onDeleteScrap: handleUnscrap,
  //   onCreateCollectionBook: handleCreateCollectionBook,
  //   onMoveCollectionBookItemList: handleMoveCollectionBookItemList,
  //   getCollectionBookList: getCollectionBookList,
  //   onClickScrapBook: handleClickScrapBook,
  //   onClickScrapBookTo: handleClickScrapBookTo,
  //   redirectToLogin,
  //   product,
  //   active: product.isScrap ?? false,
  //   count: product.scrapCount ?? 0,
  // });

  return (
    <CommerceProductCard
      product={product}
      // scrapData={scrapData}
      className={className}
      linkComponent={SuperLink}
      href={getGoodsDetailPageUrl({
        goodsId: String(product.id),
        env: APP_PROFILE === 'local' ? 'dev' : APP_PROFILE,
      })}
      logData={logData}
    />
  );
}
